"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pagination = void 0;
var React = _interopRequireWildcard(require("react"));
var _usePagination = require("../../hooks/usePagination");
var _useWindowSize = require("../../hooks/useWindowSize");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _helpers = require("../../utils/helpers");
var _Dropdown = require("../Dropdown");
var _Text = require("../Text");
var _PaginationItem = require("./PaginationItem");
var _PaginationModule = _interopRequireDefault(require("./Pagination.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LARGE_LIST_DROPDOWN_OPTIONS = 50;
const TABLET_SCREEN_SIZE = 640;
const Pagination = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    width
  } = (0, _useWindowSize.useWindowSize)();
  const showExtraSecPaginationButtons = width > TABLET_SCREEN_SIZE;
  const {
    classNames,
    style = 'primary',
    children,
    currentPage = 1,
    totalPages = 1,
    onChange,
    showFirstButton = style !== 'primary' && showExtraSecPaginationButtons,
    showLastButton = style !== 'primary' && showExtraSecPaginationButtons,
    ...restPaginationProps
  } = props;
  const showPageSelectionDropDown = style !== 'primary' && showExtraSecPaginationButtons;
  const {
    items
  } = (0, _usePagination.usePagination)({
    style,
    showFirstButton,
    showLastButton,
    currentPage,
    totalPages,
    onChange,
    ...restPaginationProps
  });
  const menuVirtualization = {
    enable: totalPages > LARGE_LIST_DROPDOWN_OPTIONS ? true : false
  };
  const allPages = (0, _helpers.range)(1, totalPages);
  const options = style !== 'secondary' ? [] : allPages.map(page => ({
    key: page.toString(),
    label: page.toString()
  }));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-testid": "Pagination",
    className: (0, _classify.default)(_PaginationModule.default.wrapper, classNames?.wrapper)
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_PaginationModule.default.childrenSlot, classNames?.children)
  }, children), /*#__PURE__*/React.createElement("div", {
    className: _PaginationModule.default.paginatorSlots
  }, style === 'secondary' && showPageSelectionDropDown && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Dropdown.Dropdown, {
    size: "small",
    classNames: {
      wrapper: _PaginationModule.default.dropdownWrapper
    },
    menu: {
      options,
      isFluid: true,
      classNames: {
        wrapper: _PaginationModule.default.menuWrapper
      },
      selectedKeys: currentPage ? [currentPage.toString()] : [],
      virtualization: menuVirtualization
    },
    dropdownInputText: currentPage.toString(),
    onChange: option => onChange?.(parseInt(option.key))
  }), !!totalPages && !!currentPage && /*#__PURE__*/React.createElement(_Text.SubTitleExtraSmall, {
    color: "tertiary",
    className: _PaginationModule.default.secondaryLabel
  }, "of ", totalPages, " ", totalPages > 1 ? 'Pages' : 'Page')), /*#__PURE__*/React.createElement("div", {
    className: (0, _classify.default)(_PaginationModule.default.paginatorSlot, classNames?.paginator)
  }, items?.map(item => /*#__PURE__*/React.createElement(_PaginationItem.PaginationItem, _extends({
    key: item.id
  }, item))))));
});
exports.Pagination = Pagination;